export const MENU_HOME = 'home'
export const MENU_VOD = 'vod'
export const MENU_LIVE = 'live'
export const MENU_LIVE_GN_CODE = 'GN54'
export const MENU_TV_CUT = 'clip'
export const MENU_MOVIE = 'movie'
export const MENU_GLOBAL = 'global'
export const MENU_PLAYY = 'playy'
export const MENU_MOVIE_17 = 'movie_17'
export const MENU_MY = 'my'
export const MENU_CATEGORY = 'category'
